// frontend/src/utils/portales.js
// Roles que trabajan exclusivamente desde su portal.
//
// Esto es UX, no seguridad: sirve para que el usuario aterrice donde
// corresponde en vez de comerse un 403 en una pantalla vacía. La traba real
// vive en el backend (`backend/apps/users/portales.py` +
// `PortalScopeMiddleware`), que responde 403 a toda ruta de la API fuera del
// portal del rol — un archivo JavaScript no puede proteger nada, porque el
// navegador es del usuario y el token viaja igual desde cualquier cliente.
//
// Al agregar un rol de portal nuevo hay que tocar los dos lados: acá para la
// navegación y en `portales.py` para el alcance real de la API.

// `/app` es la app móvil de carga en obra. Entra para los dos portales porque
// mecánicos y despachantes son justamente quienes trabajan en el campo sin
// señal. No les amplía el alcance: lo que la app puede pedirle a la API lo
// sigue decidiendo `backend/apps/users/portales.py`, y el bundle de catálogos
// se auto-limita según el rol (ver `apps/taller/sync_offline.py`).
const APP_MOVIL = '/app';

// La app es el aterrizaje de los dos roles de campo, no su portal.
//
// Mecánicos y despachantes trabajan en la obra, donde la señal va y viene, y la
// app es lo único que sigue sirviendo sin ella: los partes diarios, la ficha del
// equipo, los lubricantes y el combustible salen de la copia local y se encolan.
// El portal sigue existiendo y se abre desde la app —con las mismas pantallas de
// siempre—, pero es una parada del camino y no la puerta de entrada, porque
// entrar por ahí obliga a tener servidor justo en el momento en que menos se
// puede contar con él.
export const PORTALES = {
  mecanico: {
    inicio: APP_MOVIL,
    // Prefijos de ruta que el rol puede visitar. El portal QR entra porque es
    // público (se llega escaneando el equipo) y sus acciones ya están acotadas
    // por la grilla de permisos dentro de la propia página.
    prefijos: ['/portal-mecanico', '/qr/', APP_MOVIL],
  },
  despachante: {
    inicio: APP_MOVIL,
    prefijos: ['/portal-despacho', '/qr/', APP_MOVIL],
  },
};

/** True si el rol vive dentro de un portal cerrado. */
export const esRolDePortal = (rol) => Boolean(rol && PORTALES[rol]);

/** Ruta de aterrizaje del rol tras el login. `/` para los roles sin portal. */
export const inicioDePortal = (rol) => PORTALES[rol]?.inicio || '/';

/**
 * True si el rol puede visitar esa ruta.
 * Los roles sin portal no tienen restricción de navegación: los limita la
 * grilla de permisos, igual que antes.
 */
export const rutaPermitidaEnPortal = (rol, pathname) => {
  const portal = PORTALES[rol];
  if (!portal) return true;
  return portal.prefijos.some((prefijo) => pathname.startsWith(prefijo));
};
